import React, { useRef, useEffect } from "react";

import { Mobile as mobile } from "../../assets/expertise";
import { useTranslation } from "react-i18next";
import { HeroArea } from "../../components/heroArea";
import "./expertise.css";

export const Mobile = () => {
  const { t } = useTranslation();
  const section = useRef(null);
  useEffect(() => {
    section.current.scrollIntoView();
  }, []);
  return (
    <>
      <HeroArea />
      <div ref={section} className="service--container container">
        <h2>{t("service.mobile.title1")}</h2>
        <div className="service--content">
          <p className="paragraph">
            <h4>{t("service.mobile.title2")}</h4>
            {t("service.mobile.paragraph1")}
          </p>
          <img src={mobile} alt="mobile" className="service--img" />
        </div>
        <br />
        <div className="service--second--content">
          <h3>{t("service.methodology")}</h3>
          <h4>1 - {t("service.mobile.title3")}</h4>
          <p className="paragraph">{t("service.mobile.paragraph2")}</p>
          <h4>2 - {t("service.mobile.title4")}</h4>
          <p className="paragraph">{t("service.mobile.paragraph3")}</p>
          <h4>3 - {t("service.mobile.title5")}</h4>
          <p className="paragraph">{t("service.mobile.paragraph4")}</p>
          <h4>4 - {t("service.mobile.title6")}</h4>
          <p className="paragraph">{t("service.mobile.paragraph5")}</p>
          <h4>5 - {t("service.mobile.title7")}</h4>
          <p className="paragraph">{t("service.mobile.paragraph6")}</p>
          <h4>6 - {t("service.mobile.title8")}</h4>
          <p className="paragraph">{t("service.mobile.paragraph7")}</p>
        </div>
      </div>
    </>
  );
};
